// Map for all the assets using the key as the resource key
// also specify the URL of the resource

import { isRetina } from '@/scripts/utils';

export default {
  textures: {
    PLAIN_BLUE: {
      url: '/assets/textures/blue.png',
    },
    PLAIN_GREEN: {
      url: '/assets/textures/green.png',
    },
    PLAIN_ORANGE: {
      url: '/assets/textures/orange.png',
    },
    PLAIN_PURPLE: {
      url: '/assets/textures/purple.png',
    },
    PLAIN_RED: {
      url: '/assets/textures/red.png',
    },
    PLAIN_YELLOW: {
      url: '/assets/textures/yellow.png',
    },
    GRASS: {
      url: '/assets/textures/grass.png',
    },
    WALL: {
      url: '/assets/textures/wall.png',
    },
    SKY: {
      url: '/assets/textures/sky.png',
    },
    OBSTACLE_1: {
      url: '/assets/textures/obstacle_1.png',
    },
    OBSTACLE_2: {
      url: '/assets/textures/obstacle_2.png',
    },
    OBSTACLE_3: {
      url: '/assets/textures/obstacle_3.png',
    },
    OBSTACLE_4: {
      url: '/assets/textures/obstacle_4.png',
    },
    OBSTACLE_5: {
      url: '/assets/textures/obstacle_5.png',
    },
    OBSTACLE_6: {
      url: '/assets/textures/obstacle_6.png',
    },
    OBSTACLE_7: {
      url: '/assets/textures/obstacle_7.png',
    },
    OBSTACLE_8: {
      url: '/assets/textures/obstacle_8.png',
    },
    OBSTACLE_9: {
      url: '/assets/textures/obstacle_9.png',
    },
    OBSTACLE_10: {
      url: '/assets/textures/obstacle_10.png',
    },
    OBSTACLE_10_TALL: {
      url: '/assets/textures/obstacle_10_tall.png',
    },
    OBSTACLE_11: {
      url: '/assets/textures/obstacle_11.png',
    },
    OBSTACLE_12: {
      url: '/assets/textures/obstacle_12.png',
    },
    OBSTACLE_13: {
      url: '/assets/textures/obstacle_13.png',
    },
    OBSTACLE_13_TALL: {
      url: '/assets/textures/obstacle_13_tall.png',
    },
    OBSTACLE_14: {
      url: '/assets/textures/obstacle_14.png',
    },
    OBSTACLE_15: {
      url: '/assets/textures/obstacle_15.png',
    },
    OBSTACLE_15_TALL: {
      url: '/assets/textures/obstacle_15_tall.png',
    },
    OBSTACLE_16: {
      url: '/assets/textures/obstacle_16.png',
    },
    OBSTACLE_17: {
      url: '/assets/textures/obstacle_17.png',
    },
    OBSTACLE_18: {
      url: '/assets/textures/obstacle_18.png',
    },
    OBSTACLE_19: {
      url: '/assets/textures/obstacle_19.png',
    },
    OBSTACLE_SHADOW_1: {
      url: '/assets/textures/obstacle-shadow_1.png',
    },
    OBSTACLE_SHADOW_2: {
      url: '/assets/textures/obstacle-shadow_2.png',
    },
    OBSTACLE_SHADOW_3: {
      url: '/assets/textures/obstacle-shadow_3.png',
    },
    OBSTACLE_SHADOW_4: {
      url: '/assets/textures/obstacle-shadow_4.png',
    },
    OBSTACLE_SHADOW_5: {
      url: '/assets/textures/obstacle-shadow_5.png',
    },
    OBSTACLE_SHADOW_6: {
      url: '/assets/textures/obstacle-shadow_6.png',
    },
    OBSTACLE_SHADOW_7: {
      url: '/assets/textures/obstacle-shadow_7.png',
    },
    OBSTACLE_SHADOW_8: {
      url: '/assets/textures/obstacle-shadow_8.png',
    },
    OBSTACLE_SHADOW_9: {
      url: '/assets/textures/obstacle-shadow_9.png',
    },
    OBSTACLE_SHADOW_10: {
      url: '/assets/textures/obstacle-shadow_10.png',
    },
    OBSTACLE_SHADOW_10_TALL: {
      url: '/assets/textures/obstacle-shadow_10_tall.png',
    },
    OBSTACLE_SHADOW_11: {
      url: '/assets/textures/obstacle-shadow_11.png',
    },
    OBSTACLE_SHADOW_12: {
      url: '/assets/textures/obstacle-shadow_12.png',
    },
    OBSTACLE_SHADOW_13: {
      url: '/assets/textures/obstacle-shadow_13.png',
    },
    OBSTACLE_SHADOW_13_TALL: {
      url: '/assets/textures/obstacle-shadow_13_tall.png',
    },
    OBSTACLE_SHADOW_14: {
      url: '/assets/textures/obstacle-shadow_14.png',
    },
    OBSTACLE_SHADOW_15: {
      url: '/assets/textures/obstacle-shadow_15.png',
    },
    OBSTACLE_SHADOW_15_TALL: {
      url: '/assets/textures/obstacle-shadow_15_tall.png',
    },
    OBSTACLE_SHADOW_16: {
      url: '/assets/textures/obstacle-shadow_16.png',
    },
    CLOUDS_BACKGROUND_FAR: {
      url: '/assets/textures/clouds_background_far.png',
    },
    CLOUDS_BACKGROUND_MID: {
      url: '/assets/textures/clouds_background_mid.png',
    },
    CLOUDS_BACKGROUND_NEAR: {
      url: '/assets/textures/clouds_background_near.png',
    },
    CLOUDS_FOREGROUND: {
      url: '/assets/textures/clouds_foreground.png',
    },
    SCARECROW: {
      url: '/assets/textures/scarecrow.png',
    },
    SEED: {
      url: '/assets/textures/seed.png',
    },
  },
  sprites: {
    BIRD_BODY: {
      url: `/assets/sprites${isRetina() ? '/2x' : ''}/bird_body.json`,
    },
    BIRD_SHIELD_FORE: {
      url: `/assets/sprites${isRetina() ? '/2x' : ''}/bird-shield_fore.json`,
    },
    BIRD_SHIELD_BACK: {
      url: `/assets/sprites${isRetina() ? '/2x' : ''}/bird-shield_back.json`,
    },
    BIRD_SHIELD_FORE_LIGHT: {
      url: `/assets/sprites${isRetina() ? '/2x' : ''}/bird-shield-light_fore.json`,
    },
    BIRD_SHIELD_BACK_LIGHT: {
      url: `/assets/sprites${isRetina() ? '/2x' : ''}/bird-shield-light_back.json`,
    },
    BIRD_SHIELD_FORE_HEAVY: {
      url: `/assets/sprites${isRetina() ? '/2x' : ''}/bird-shield-heavy_fore.json`,
    },
    BIRD_SHIELD_BACK_HEAVY: {
      url: `/assets/sprites${isRetina() ? '/2x' : ''}/bird-shield-heavy_back.json`,
    },
    POWERUP_1: {
      url: '/assets/sprites/powerup_1.json',
    },
    POWERUP_2: {
      url: '/assets/sprites/powerup_2.json',
    },
    POWERUP_LINES_1: {
      url: '/assets/sprites/powerup_lines_1.json',
    },
    POWERUP_LINES_2: {
      url: '/assets/sprites/powerup_lines_2.json',
    },
    OBSTACLE_FACE_17: {
      url: '/assets/sprites/obstacle-face_17.json',
    },
    OBSTACLE_FACE_18: {
      url: '/assets/sprites/obstacle-face_18.json',
    },
    OBSTACLE_FACE_19: {
      url: '/assets/sprites/obstacle-face_19.json',
    },
    LIGHT: {
      url: '/assets/sprites/light.json',
    },
    HEAVY: {
      url: '/assets/sprites/heavy.json',
    },
  },
};
